import { BasketItemSource } from '@epicuro-next/models/basket';

import { TrackListSource } from '../models';

export function trackSourceToBasketSource(
  trackListSource: TrackListSource,
): BasketItemSource {
  switch (trackListSource) {
    case 'email':
      return BasketItemSource.LIST_EMAIL;
    case 'spotlight':
    case 'newsfeed':
      return BasketItemSource.LIST_SPOTLIGHT;
    case 'landing-page':
      return BasketItemSource.LIST_LANDING_PAGE;
    case 'recommendation-panels':
      return BasketItemSource.RECOMMENDATION_PANEL;
    case 'link':
    case 'url':
    case 'my-list':
    default:
      return BasketItemSource.LIST_LOCAL;
  }
}
